class BrowserStorage {
    constructor(rootKey = 'TESTING_ONLY_SESSION_DATA', options) {
        this.catchError = (func, ...args) => {
            delete this.lastError;
            try {
                return func(...args);
            }
            catch (e) {
                this.lastError = e;
            }
            return null;
        };
        // @ts-ignore
        this.getItem = () => this.catchError(() => this.options.deserialize(this.options.storage.getItem(this.options.rootKey)));
        // @ts-ignore
        this.setItem = (value) => this.catchError(() => this.options.storage.setItem(this.options.rootKey, this.options.serialize(value)));
        // @ts-ignore
        this.removeItem = () => this.catchError(() => this.options.storage.removeItem(this.options.rootKey));
        this.getLastError = () => this.lastError;
        this.options = Object.assign({ rootKey, storage: options.persist ? globalThis.localStorage : globalThis.sessionStorage, serialize: JSON.stringify, deserialize: JSON.parse }, options);
    }
}

const CONTEXT_SEARCH_UTILITY_ENVIRONMENT = 'CONTEXT_SEARCH_UTILITY_ENVIRONMENT';
const extractOptions = (paramValue = '') => {
    const options = {};
    const paramArray = (paramValue === null || paramValue === void 0 ? void 0 : paramValue.split('|')) || [];
    if (paramArray.length > 0) {
        if (paramArray[0]) {
            const env = String(paramArray[0]);
            options.env = env === null || env === void 0 ? void 0 : env.toUpperCase();
        }
        if (paramArray[1]) {
            options.version = paramArray[1];
        }
    }
    return options;
};
const getQueryOptions = () => {
    // Qstring Pattern -> context_search_utility_environment=env|version
    // Example1: context_search_utility_environment=PR|111
    // Example2: context_search_utility_environment=|v0
    // Example3: context_search_utility_environment=PROD
    var _a;
    let options = {};
    const browserStorage = new BrowserStorage(CONTEXT_SEARCH_UTILITY_ENVIRONMENT, { persist: true });
    const searchParams = new URLSearchParams((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _a === void 0 ? void 0 : _a.search);
    let paramValueString = (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('context_search_utility_environment')) || '';
    if (paramValueString) {
        options = extractOptions(paramValueString);
        browserStorage.setItem(paramValueString);
        return options;
    }
    // Check local storage
    paramValueString = browserStorage.getItem();
    if (paramValueString) {
        options = extractOptions(paramValueString);
    }
    return options;
};

const NONPROD = 'NONPROD';
const PROD = 'PROD';
/* */
const getEnvironment = () => {
    var _a;
    if ([
        'speedy.autotrader.com',
        'www.autotrader.com',
        'www.kbb.com',
    ].includes((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.location) === null || _a === void 0 ? void 0 : _a.hostname)) {
        return PROD;
    }
    return NONPROD;
};

const DEFAULT_CONTEXT_UTILITY_VERSION = 'v0';

const isNumeric = (val) => /^\d+$/.test(val);

const getComponentURL = ({ env = getEnvironment(), version = DEFAULT_CONTEXT_UTILITY_VERSION }, entryPoint) => {
    const componentURL = {
        utilityURL: {
            PROD: `https://contextual-search.awscconsumerinfo.autotrader.com/prod/${version}/cai-context-search-util.esm.js`,
            NONPROD: `https://contextual-search.awscconsumerinfonp.autotrader.com/nonprod/${version}/cai-context-search-util.esm.js`,
            PR: `https://contextual-search.awscconsumerinfonp.autotrader.com/pr/${version}/cai-context-search-util.esm.js`,
        },
        webComponentURL: {
            PROD: `https://contextual-search.awscconsumerinfo.autotrader.com/prod/${version}/cai-context-search-web-components.esm.js`,
            NONPROD: `https://contextual-search.awscconsumerinfonp.autotrader.com/nonprod/${version}/cai-context-search-web-components.esm.js`,
            PR: `https://contextual-search.awscconsumerinfonp.autotrader.com/pr/${version}/cai-context-search-web-components.esm.js`,
        },
    };
    return componentURL[entryPoint][env];
};
const getEsmModulePath = ({ env, version }, entryPoint = 'utilityURL') => {
    if (env === 'PR' && !isNumeric(version)) {
        throw new Error(`Version must be a number when env is set to 'PR'.`);
    }
    return getComponentURL({ env, version }, entryPoint);
};

// Run a build in the root folder to ensure this module exists.
//type ModuleType = typeof import('./contextual-search-utility');
// TODO: uncomment line above and change return type of getContextSearchUtilities to Promise<ModuleType>
const getContextSearchUtilities = async (options = {}) => {
    if (typeof window === 'undefined') {
        throw new Error('contextual-search-utility can only be loaded in a browser');
    }
    const SCRIPT_URL = getEsmModulePath(Object.assign(Object.assign({}, options), getQueryOptions()), 'utilityURL');
    return await import(/* webpackIgnore: true */ SCRIPT_URL);
};

const getContexSearchUtilityURL = (options = {}) => getEsmModulePath(Object.assign(Object.assign({}, options), getQueryOptions()), 'utilityURL');

const getContextSearchWebComponentURL = (options = {}) => getEsmModulePath(Object.assign(Object.assign({}, options), getQueryOptions()), 'webComponentURL');

export { getContexSearchUtilityURL, getContextSearchUtilities, getContextSearchWebComponentURL };
//# sourceMappingURL=index.mjs.map
